import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`GHG_EmissoesFugitivas2/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td>{rs.registroFonte}</td>
                    <td>{rs.descricaoFonte}</td>
                    <td>{rs.gasEfeitoEstufa}</td>
                    <td>{rs.emissoesKgGEE}</td>
                    <td>{rs.emissoesCO2}</td>
                    
                    
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th tyle={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Registro Fonte
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Descricao Fonte
                                </center>

                            </th>
                        
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Gas Efeito EStufa
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes Kg GEE
                                </center>

                            </th>


                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup>
                                </center>

                            </th>
                            
                            

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel